/**
 * @fileoverview gRPC-Web generated client stub for zk.master
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as brevis_explorer_statistics_pb from '../brevis_explorer/statistics_pb';


export class BrevisExplorerClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetAppInfos = new grpcWeb.MethodDescriptor(
    '/zk.master.BrevisExplorer/GetAppInfos',
    grpcWeb.MethodType.UNARY,
    brevis_explorer_statistics_pb.GetAppInfosRequest,
    brevis_explorer_statistics_pb.GetAppInfosResponse,
    (request: brevis_explorer_statistics_pb.GetAppInfosRequest) => {
      return request.serializeBinary();
    },
    brevis_explorer_statistics_pb.GetAppInfosResponse.deserializeBinary
  );

  getAppInfos(
    request: brevis_explorer_statistics_pb.GetAppInfosRequest,
    metadata: grpcWeb.Metadata | null): Promise<brevis_explorer_statistics_pb.GetAppInfosResponse>;

  getAppInfos(
    request: brevis_explorer_statistics_pb.GetAppInfosRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppInfosResponse) => void): grpcWeb.ClientReadableStream<brevis_explorer_statistics_pb.GetAppInfosResponse>;

  getAppInfos(
    request: brevis_explorer_statistics_pb.GetAppInfosRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppInfosResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/zk.master.BrevisExplorer/GetAppInfos',
        request,
        metadata || {},
        this.methodInfoGetAppInfos,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/zk.master.BrevisExplorer/GetAppInfos',
    request,
    metadata || {},
    this.methodInfoGetAppInfos);
  }

  methodInfoGetProofsNumByAppName = new grpcWeb.MethodDescriptor(
    '/zk.master.BrevisExplorer/GetProofsNumByAppName',
    grpcWeb.MethodType.UNARY,
    brevis_explorer_statistics_pb.GetAppDataRequest,
    brevis_explorer_statistics_pb.GetAppDataResponse,
    (request: brevis_explorer_statistics_pb.GetAppDataRequest) => {
      return request.serializeBinary();
    },
    brevis_explorer_statistics_pb.GetAppDataResponse.deserializeBinary
  );

  getProofsNumByAppName(
    request: brevis_explorer_statistics_pb.GetAppDataRequest,
    metadata: grpcWeb.Metadata | null): Promise<brevis_explorer_statistics_pb.GetAppDataResponse>;

  getProofsNumByAppName(
    request: brevis_explorer_statistics_pb.GetAppDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppDataResponse) => void): grpcWeb.ClientReadableStream<brevis_explorer_statistics_pb.GetAppDataResponse>;

  getProofsNumByAppName(
    request: brevis_explorer_statistics_pb.GetAppDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/zk.master.BrevisExplorer/GetProofsNumByAppName',
        request,
        metadata || {},
        this.methodInfoGetProofsNumByAppName,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/zk.master.BrevisExplorer/GetProofsNumByAppName',
    request,
    metadata || {},
    this.methodInfoGetProofsNumByAppName);
  }

  methodInfoGetAppRequestNumByAppName = new grpcWeb.MethodDescriptor(
    '/zk.master.BrevisExplorer/GetAppRequestNumByAppName',
    grpcWeb.MethodType.UNARY,
    brevis_explorer_statistics_pb.GetAppDataRequest,
    brevis_explorer_statistics_pb.GetAppDataResponse,
    (request: brevis_explorer_statistics_pb.GetAppDataRequest) => {
      return request.serializeBinary();
    },
    brevis_explorer_statistics_pb.GetAppDataResponse.deserializeBinary
  );

  getAppRequestNumByAppName(
    request: brevis_explorer_statistics_pb.GetAppDataRequest,
    metadata: grpcWeb.Metadata | null): Promise<brevis_explorer_statistics_pb.GetAppDataResponse>;

  getAppRequestNumByAppName(
    request: brevis_explorer_statistics_pb.GetAppDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppDataResponse) => void): grpcWeb.ClientReadableStream<brevis_explorer_statistics_pb.GetAppDataResponse>;

  getAppRequestNumByAppName(
    request: brevis_explorer_statistics_pb.GetAppDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/zk.master.BrevisExplorer/GetAppRequestNumByAppName',
        request,
        metadata || {},
        this.methodInfoGetAppRequestNumByAppName,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/zk.master.BrevisExplorer/GetAppRequestNumByAppName',
    request,
    metadata || {},
    this.methodInfoGetAppRequestNumByAppName);
  }

  methodInfoAddProofUser = new grpcWeb.MethodDescriptor(
    '/zk.master.BrevisExplorer/AddProofUser',
    grpcWeb.MethodType.UNARY,
    brevis_explorer_statistics_pb.AddProofUserRequest,
    brevis_explorer_statistics_pb.AddProofUserResponse,
    (request: brevis_explorer_statistics_pb.AddProofUserRequest) => {
      return request.serializeBinary();
    },
    brevis_explorer_statistics_pb.AddProofUserResponse.deserializeBinary
  );

  addProofUser(
    request: brevis_explorer_statistics_pb.AddProofUserRequest,
    metadata: grpcWeb.Metadata | null): Promise<brevis_explorer_statistics_pb.AddProofUserResponse>;

  addProofUser(
    request: brevis_explorer_statistics_pb.AddProofUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.AddProofUserResponse) => void): grpcWeb.ClientReadableStream<brevis_explorer_statistics_pb.AddProofUserResponse>;

  addProofUser(
    request: brevis_explorer_statistics_pb.AddProofUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.AddProofUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/zk.master.BrevisExplorer/AddProofUser',
        request,
        metadata || {},
        this.methodInfoAddProofUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/zk.master.BrevisExplorer/AddProofUser',
    request,
    metadata || {},
    this.methodInfoAddProofUser);
  }

  methodInfoGetUniqAddress = new grpcWeb.MethodDescriptor(
    '/zk.master.BrevisExplorer/GetUniqAddress',
    grpcWeb.MethodType.UNARY,
    brevis_explorer_statistics_pb.GetUniqAddressRequest,
    brevis_explorer_statistics_pb.GetAppDataResponse,
    (request: brevis_explorer_statistics_pb.GetUniqAddressRequest) => {
      return request.serializeBinary();
    },
    brevis_explorer_statistics_pb.GetAppDataResponse.deserializeBinary
  );

  getUniqAddress(
    request: brevis_explorer_statistics_pb.GetUniqAddressRequest,
    metadata: grpcWeb.Metadata | null): Promise<brevis_explorer_statistics_pb.GetAppDataResponse>;

  getUniqAddress(
    request: brevis_explorer_statistics_pb.GetUniqAddressRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppDataResponse) => void): grpcWeb.ClientReadableStream<brevis_explorer_statistics_pb.GetAppDataResponse>;

  getUniqAddress(
    request: brevis_explorer_statistics_pb.GetUniqAddressRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/zk.master.BrevisExplorer/GetUniqAddress',
        request,
        metadata || {},
        this.methodInfoGetUniqAddress,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/zk.master.BrevisExplorer/GetUniqAddress',
    request,
    metadata || {},
    this.methodInfoGetUniqAddress);
  }

  methodInfoGetAppsOverallData = new grpcWeb.MethodDescriptor(
    '/zk.master.BrevisExplorer/GetAppsOverallData',
    grpcWeb.MethodType.UNARY,
    brevis_explorer_statistics_pb.GetAppsOverallDataRequest,
    brevis_explorer_statistics_pb.GetAppsOverallDataResponse,
    (request: brevis_explorer_statistics_pb.GetAppsOverallDataRequest) => {
      return request.serializeBinary();
    },
    brevis_explorer_statistics_pb.GetAppsOverallDataResponse.deserializeBinary
  );

  getAppsOverallData(
    request: brevis_explorer_statistics_pb.GetAppsOverallDataRequest,
    metadata: grpcWeb.Metadata | null): Promise<brevis_explorer_statistics_pb.GetAppsOverallDataResponse>;

  getAppsOverallData(
    request: brevis_explorer_statistics_pb.GetAppsOverallDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppsOverallDataResponse) => void): grpcWeb.ClientReadableStream<brevis_explorer_statistics_pb.GetAppsOverallDataResponse>;

  getAppsOverallData(
    request: brevis_explorer_statistics_pb.GetAppsOverallDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: brevis_explorer_statistics_pb.GetAppsOverallDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/zk.master.BrevisExplorer/GetAppsOverallData',
        request,
        metadata || {},
        this.methodInfoGetAppsOverallData,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/zk.master.BrevisExplorer/GetAppsOverallData',
    request,
    metadata || {},
    this.methodInfoGetAppsOverallData);
  }

}

